export const profileVideos = [
  {
    id: 1,
    name: "Hudl Film",
  },
  {
    id: 2,
    name: "Basketball Highlights",
  },
  {
    id: 3,
    name: "100 Meter Track Time",
  },
  {
    id: 4,
    name: "7 on 7 Highlights",
  },
  {
    id: 5,
    name: "1 on 1s",
  },
  {
    id: 6,
    name: "Weight Room",
  },
];
